import React from 'react';
import { Label } from '../../core/label';
import { useSelector } from 'react-redux';
import { getLabelsListByCode } from 'shared/store/selectors/labels.selector';
import { IconButton } from 'src/components/design-system';

const LabelsList = React.memo(({ labels = [], className }) => {
  const labelsItems = useSelector(
    state => getLabelsListByCode(state, labels),
    (a, b) => {
      return a?.length === b?.length;
    },
  );

  if (!labelsItems?.length) return null;

  return labelsItems.map(label => (
    <IconButton label={label.name} tooltipProps={{ placement: 'topLeft' }} key={label.code}>
      <Label color={label.color} value={label.code} className={className} />
    </IconButton>
  ));
});

export { LabelsList };
